import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  cartCount: 0,
   refreshCart: false,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCart: (state, action) => {
      state.cartCount = action.payload.count;  // API cart count
    },

    clearCart: (state) => {
      state.cartCount = 0;
    },
    toggleCartRefresh: (state) => {
      state.refreshCart = !state.refreshCart; // 🔥 toggle
    },
  },
});

export const { setCart, clearCart, toggleCartRefresh } = cartSlice.actions;
export default cartSlice.reducer;